<template>
  <i
    v-if="$isWeb"
    :class="['iconfont', 'icon-' + name, svgClass]"
    :style="{ color: color, fontSize: width, lineHeight: height, bold: true }"
  />
  <view
    v-else
    :class="['iconfont', 'icon-' + name, svgClass]"
    :style="{ color: color, fontSize: width, lineHeight: height, bold: true }"
  />
</template>
<script>
export default {
  name: 'Iconfont',
  components: {},
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    svgClass() {
      return 'cube-icon-font' + ` ${this.className}` || ''
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
@import './iconfont.css';
.cube-icon-font {
  font-size: 1rem;
  line-height: 1rem;
  cursor: pointer;
  // 不能用 baseline，因为设计图标字体时没有预留 baseline
  // 为了和其他格式图标的对齐，必须用 bottom
  vertical-align: bottom;
  fill: currentColor;
  overflow: hidden;
}
.cube-icon-font {
  display: inline-block;
}
.font-size-100 .cube-icon-font {
  font-size: 0.16rem;
  line-height: 0.16rem;
}
</style>
